/**
 * Given a number, returns a string of fixed length, leading with 0's.
 * E.g. given number 99, and length 4, returns '0099'.
 * @param number
 * @param length
 * @returns
 */
export const numberToFixedLengthString = (
  number: number,
  length: number,
): string =>
  number
    // Convert to string, where number is made to decimals
    .toLocaleString('da-dk', { minimumIntegerDigits: length })
    // Replace '.' with '', ensuring output is not a decimal
    .replace('.', '');

/**
 * Safely divides two numbers, ensuring no division by zero errors.
 * If denominator is 0, returns null.
 * @param numerator
 * @param denominator
 * @returns
 */
export const safeDivision = (
  numerator: number,
  denominator: number,
): number | null => {
  if (!denominator) return null;
  if (!numerator) return 0;

  return numerator / denominator;
};
